import React , {useEffect, useState} from 'react';
import BarcodeScanner from 'react-qr-barcode-scanner';
import { AreaTitle } from './appBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFaceFrown, faFaceSmile, faCalendar, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { ListView, ListViewHeader, ListViewFooter, ListViewItemProps } from '@progress/kendo-react-listview';
import { Dialog, DialogActionsBar} from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';



export const MyReservations =()=>{
    const [showScanner,setShowScanner]=useState(true);
    const [scanValue,setScanValue]=useState("");    
    const [gridData,setGridData]=useState([]);
    const [contData,setContData]=useState([]);
    const [manEntry, setManEntry]=useState("");
    const [manConfirm,setManConfirm]=useState(false);
    const [showManual,setShowManual]=useState(false);
    const [manParticipant,setManParticipant]=useState(undefined);
    
    //const tomorrow = new Date("07/23/2026");
    //tomorrow.setDate(tomorrow.getDate() + 1);
    //const currTime =new Date().getHours();
    
    const openScanner=()=>{
        console.log("Open Scanner");
        setScanValue("");
    }
    const hideScanner=()=>{
        setShowScanner(false);
    }

    const openManual=()=>{
        console.log("Open Manual");
        clearParticipant();
        setShowManual(true);
    }

    const closeManual=()=>{
        setShowManual(false);
    }


    const getMyRes = async ()=>{
        //const domain = window.location.host;
        //const tmdt = tomorrow.toISOString().split('T')[0];
        //const tmdt='2026-07-23';
        const url = "api/index.php/program/getMyRes?id="+scanValue;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            if (data.length>0){
                setGridData(data);
            }
        })
    }

    const getMyContRes = async ()=>{
        //const domain = window.location.host;
        //const tmdt = tomorrow.toISOString().split('T')[0];
        //const tmdt='2026-07-23';
        const url = "api/index.php/program/getMyContRes?id="+scanValue;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            if (data.length>0){
                setContData(data);
            }
        })
    }

   const onScan=(err,result)=>{
        if (result){
            console.log(result);
            setScanValue(result.text);
            hideScanner();
        }
    }
    const clearParticipant=()=>{
        setManParticipant(undefined);
    }

    const ManualEntry=()=>{
        const manualIDChange=(event)=>{
            console.log(event.value);
            setManEntry(event.value);
        }
        const checkManParticipant = async ()=>{
            if (manEntry!=""){
                const params=new URLSearchParams({id:manEntry, name:""});
                const url= "api/index.php/program/getParticipant?" + params;
                fetch (url,{
                    method:"GET"
                }).then(response=>response.json()).then(async data=> {
                    console.log(data);
                    setManParticipant(data);
                })
            }
        }
        
        const saveManual=()=>{
            setScanValue(manParticipant[0].MemberId)
            closeManual();
            hideScanner();
            setManEntry("");
        }

        return(
            <Dialog className='atol-dlg-error' title={"Enter manual ID"} onClose={closeManual}>
                <p>Enter the ID number found on your Jamboree ID</p>
                <Input onChange={manualIDChange} value={manEntry}></Input>
                {manParticipant?    
                <>
                <p>Are you {manParticipant[0].NameFirst} {manParticipant[0].NameLast}?</p>
                <Button onClick={saveManual}>Yes</Button>
                <Button onClick={clearParticipant}>No</Button>    
                </>
                :null}
                <DialogActionsBar>
                    {manConfirm?
                        <Button>Save</Button>                
                    :
                        <Button onClick={checkManParticipant}>Check ID</Button>
                    }

                </DialogActionsBar>
            </Dialog>
        )
    }

    const itemRender=(props)=>{
        let item = props.dataItem;
        const dt = new Date(item.Date + "T" + item.StartTime)
        console.log(dt);
        const actDate = dt.toDateString();
        const actTime = dt.toLocaleTimeString([], { timeStyle: 'short' });
        console.log(actDate)
        console.log(actTime);
        return(
            <>
            <div className='k-listview-item' style={{textAlign:"left", paddingLeft:"10px", paddingRight:"10px", paddingTop:"5px", paddingBottom:"5px", backgroundColor:"var(--kendo-color-primary)", color:"var(--kendo-color-on-primary"}}>
                <h2><FontAwesomeIcon icon={faCalendarDays} style={{fontSize:"xx-large"}}/>&emsp;{item.AreaName}</h2>
            </div>
            <div style={{backgroundColor:"var(--kendo-color-light)", padding:"10px"}}>
            <div style={{textAlign:"left"}}>
                <h3>{actDate} &emsp; Check-in at: {actTime}</h3>
            </div>
            <div style={{textAlign:"left"}}>
                <p>{item.Description}</p>
                <p><a href={item.Location} target='_blank'>Find the check-in Location</a></p>
            </div>
            </div>
            </>
        )
    }

    useEffect(()=>{
        console.log("Scan Value changed")
        console.log(scanValue);
        if (scanValue!==""){
            getMyRes();
            getMyContRes();
        }else{
            setShowScanner(true);
        }
    },[scanValue])



    return(
        <div className="App">
        <AreaTitle area={"My Reservations"}></AreaTitle>
        {showScanner?
            <>
            {showManual?
                <ManualEntry></ManualEntry>
            :null}
            <h3>Check Your Reservations</h3>
            <p>Scan the barcode on your Jamboree ID<br/>to view your program reservations.</p>
            <Button onClick={openManual}>Having trouble reading the barcode?</Button>
            <BarcodeScanner onUpdate={onScan}></BarcodeScanner>
            </>
        :
            //display scan results
            <>
            {gridData.length>0?
                <>
                <h3>Hi {gridData.length>0?gridData[0].NameFirst + " " + gridData[0].NameLast:null}!</h3>
                <p>Here are the reservations we found for you</p>
                <ListView data={gridData} item={itemRender}/>
                <ListView data={contData} item={itemRender}/>
                </>
            :
            //No reservations found.
                <div style={{padding:"20px"}}>
                    <div style={{fontSize:"xxx-Large", color:"darkorange"}}><FontAwesomeIcon icon={faFaceFrown}/></div>
                    <h3>No Reservations Found</h3>
                    <p>Sorry. You do not have any reservations at the moment.</p>
                </div>
            }
            
            <div style={{marginTop:"10px"}}>
                <Button onClick={openScanner} size='large' themeColor='primary' fillMode='outline'>Scan Another Id</Button>
            </div>
            </>
        }
        </div>
    )
}